<template>

  <div class="cf">
    <div class="cf-success">

      <!-- blad przetwarzania wniosku (komunikat ustawiony przez DynamicForm) -->
      <template v-if="pendingMessage">
        <span class="cf-success__icon cf-success__icon--warn">!</span>

        <div class="cf-stack" style="gap:10px;align-items:center">
          <span class="cf-eyebrow cf-eyebrow--muted">Wniosek</span>
          <h1 class="cf-h1">Nie udało się przetworzyć Twojego wniosku</h1>
          <p class="cf-lead" style="margin:0 auto"><strong>{{ pendingMessage }}</strong></p>
          <p class="cf-lead" style="margin:0 auto">W razie pytań prosimy o kontakt z infolinią
            <a href="tel:226967270" class="cf-nowrap"><strong>22 696 72 70</strong></a>.</p>
        </div>
      </template>


      <!-- wniosek w trakcie przetwarzania -->
      <template v-else>
        <span class="cf-success__icon">⏳</span>

        <div class="cf-stack" style="gap:10px;align-items:center">
          <span class="cf-eyebrow">Wniosek w trakcie przetwarzania</span>
          <h1 class="cf-h1">Dziękujemy za cierpliwość</h1>
          <p class="cf-lead" style="margin:0 auto">Twój wniosek jest w trakcie procesowania. Niebawem się z Tobą skontaktujemy
            — o kolejnych krokach poinformujemy Cię SMS-em i e-mailem.</p>
        </div>

        <div class="cf-row" style="justify-content:center">
          <a v-if="$root.mainpage && $root.mainpage.loggedIn" class="cf-btn cf-btn--primary" @click="$router.push({path: '/client'})">Przejdź do strefy klienta</a>
        </div>
      </template>

    </div>
  </div>

</template>

<script>



  export default {

    name: 'ZetosTimeoutPage',


    data() {

      return {

      }
    },


    computed: {

      // komunikat bledu ustawiony przez DynamicForm na root page (NauPage)
      pendingMessage() {

        return this.$root.mainpage ? this.$root.mainpage.pendingMessage : '';
      }
    },
  }
</script>

<style scoped>

.cf-page {
  padding: 44px 64px 56px;
  max-width: 960px;
}

.cf-easycheck__widget {
  padding: 24px;
  display: flex;
  justify-content: center;
}

@media (max-width: 900px) {

  .cf-page {
    padding: 24px 18px 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/ZetosTimeoutPage.vue